import React from 'react';
import ImageAttachment from '../../../../components/Misc/ImageAttachment';
import FormAccountAddress from './FormAccountAddress';
import { useAccountContext } from '../Data/accountContext';

export default function FormAccountAddressPrimary({ validation }) {
  const { isBussinessAccount, account, setAccount } = useAccountContext();

  const setData = (data) => {
    const copy = { ...account };
    copy.primaryOwner = { ...data };

    setAccount(copy);
  };

  return (
    <div className="grd-row">
      <div className="grd-cell-none mr">
        <ImageAttachment
          id="imgProofOfAddress"
          label="Proof of Address"
          thumbnail={account.primaryOwner.imgProofOfAddress}
          data={account.primaryOwner}
          setNewData={setData}
        />
      </div>
      <div className="grd-cell">
        <FormAccountAddress
          validation={validation}
          isBusinessAddress={isBussinessAccount()}
          objectName="primaryOwner"
        />
      </div>
    </div>
  );
}
